// Gedeelde keuzelijsten voor het monteursprofiel (NL/BE)

export const WERKSTATUUT = [
  { value: "zelfstandige", label: "Zelfstandige — in orde met de Belgische wetgeving" },
  { value: "flexi", label: "Flexi-job — ik kom hiervoor in aanmerking" },
  { value: "loondienst", label: "Loondienst — full-time of part-time" },
];

export const VERVOER = [
  { value: "eigen_bestelwagen", label: "Ik heb een eigen bestelwagen" },
  { value: "eigen_vervoer_geen_bestelwagen", label: "Eigen vervoer, maar geen bestelwagen" },
  { value: "geen_vervoer", label: "Ik heb geen eigen vervoer" },
];

export const RIJBEWIJZEN = ["B", "BE", "C", "CE"];

export const WERKMATERIAAL = [
  { value: "eigen", label: "Ik heb mijn eigen werkmateriaal" },
  { value: "geen", label: "Ik heb geen werkmateriaal" },
];

export const SPEC_MONTAGE = [
  { value: "ramen_deuren", label: "Ramen en deuren plaatsen" },
  { value: "garagepoorten", label: "Garagepoorten plaatsen" },
  { value: "velux", label: "Velux-ramen plaatsen" },
];

export const SPEC_AFWERKING = [
  { value: "pvc", label: "Binnenafwerking in PVC" },
  { value: "mdf", label: "Binnenafwerking in MDF" },
  { value: "pleisterwerk", label: "Binnenafwerking met pleisterwerk" },
];

export const TALEN = ["Nederlands", "Frans", "Engels", "Duits"];

export const LABELS = {
  zelfstandige: "Zelfstandige",
  flexi: "Flexi-job",
  loondienst: "Loondienst",
  eigen_bestelwagen: "Eigen bestelwagen",
  eigen_vervoer_geen_bestelwagen: "Eigen vervoer (geen bestelwagen)",
  geen_vervoer: "Geen eigen vervoer",
  eigen: "Eigen werkmateriaal",
  geen: "Geen werkmateriaal",
  ramen_deuren: "Ramen & deuren",
  garagepoorten: "Garagepoorten",
  velux: "Velux-ramen",
  pvc: "Afwerking PVC",
  mdf: "Afwerking MDF",
  pleisterwerk: "Pleisterwerk",
};
